module.exports = __webpack_public_path__ + "static/assets/4f2885172e42580ef5674c3646a1be2b.png";